import React from 'react';
import Typography from './Typography';
import backgroundcard from '../images/Rectangle 4393.png';

const OverviewCustomCard = ({ title, value, children, icon }) => {
    return (
        <div className="lg:px-4 px-2 relative md:w-full h-full">
            <img src={backgroundcard} alt='backgroundcard' className='absolute top-0 left-0 w-full h-full' />
            <div className="relative z-10 flex flex-col h-full text-white">
                <div className='mt-[14px]'>{icon}</div>
                {title && <Typography color={'#DF0F11'} className='mt-[30px]' size={'10px'} weight={400} lineheight={'170%'} text={title} />}
                {value && <Typography color={'#FFF'} className='mb-5 max-lg:truncate' text={value} family={'Supply'} size={'20px'} weight={500} lineheight={'170%'} />}
            </div>
        </div>
    );
};

export default OverviewCustomCard;